module.exports = __webpack_public_path__ + "media/images/emblems/Affoltern_am_Albis-blazon-f0694bc3cd94c4b22794171ddf65fb23.svg";